const LoginBg = () => {
  return (
    <div
      className="flex h-dvh w-screen items-center justify-center px-4 pt-6 text-white"
      style={{
        background: "linear-gradient(180deg, #4A4A76 0%, #292934 100%)",
      }}
    >
      <img
        src="/images/login-bl-blur.svg"
        alt=""
        className="absolute bottom-0 left-0"
      />
      <div className="relative -translate-y-5">
        <h1 className="z-10 mx-auto w-4/5 min-w-80 text-3xl font-bold text-white md:text-6xl md:leading-14">
          The New Standard of Digital Finance.
        </h1>
        <p className="mx-auto mt-4 w-4/5 min-w-80 text-base md:text-2xl">
          Easily create virtual cards to handle every online purchase, bill, and
          subscription.
        </p>
        <div className="relative z-10 mt-4 w-4/5 min-w-80 md:w-[600px]">
          {" "}
          <img
            src="/images/grid-dot.svg"
            alt="grid dot"
            className="absolute -top-5 -right-5 size-8"
          />
          <img
            src="/images/grid-dot.svg"
            alt="grid dot"
            className="absolute -right-3 -bottom-20 size-8"
          />
          <img src="/images/login-atm.png" alt="Atm cards" />
          <div className="flex justify-end">
            <img
              src="/images/login-icon-set.png"
              className="bottom-0 w-32"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginBg;
